var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"officebodyContent"},[_c('FloatingContactControls'),_c('div',{staticClass:"mainContent"},[_c('mainpage')],1),_c('div',{staticClass:"footer"},[_c('footerBlock',{staticClass:"homeFooterBlock"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }